module.exports = __webpack_public_path__ + "static/media/Bg_user.f981e40e.png";